/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.space.putRecord'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  space: /*#__PURE__*/ l.string(),
  repo: /*#__PURE__*/ l.string({ format: 'did' }),
  collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  rkey: /*#__PURE__*/ l.string({ format: 'record-key', maxLength: 512 }),
  validate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  record: /*#__PURE__*/ l.lexMap(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  uri: /*#__PURE__*/ l.string(),
  cid: /*#__PURE__*/ l.string({ format: 'cid' }),
  validationStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Write a record in a permissioned space, creating or updating it as needed. Requires auth, implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'SpaceNotFound',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
